import axios, { HttpStatusCode } from "axios";
import { clearAuthenticationData, logoutAsync } from "../authentication/authenticationSlice";
import { ACCOUNT_BLOCKED_QUERY, isAccountBlockedError } from "../authentication/utils/accountBlocked";
import { API_BASE_URL } from "../../config";

let storeInstance: any = null;
let isLoggingOut = false;

export const injectStore = (_store: any) => {
  storeInstance = _store;
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL + "/api",
  withCredentials: true,
});

const handleUnauthorized = () => {
  if (!isLoggingOut && storeInstance) {
    isLoggingOut = true;
    storeInstance.dispatch(logoutAsync()).finally(() => {
      isLoggingOut = false;
    });
  }
};

/** Blocked by the platform (US-111): drop the session here, no IdentityServer round trip, and show the line. */
const handleBlocked = () => {
  storeInstance?.dispatch(clearAuthenticationData());
  window.location.assign(`/login?${ACCOUNT_BLOCKED_QUERY}`);
};

axiosInstance.interceptors.request.use(
  (requestConfig) => {
    const token =
      storeInstance?.getState().authentication.userAuth?.access_token;
    if (token) {
      requestConfig.headers["Authorization"] = `Bearer ${token}`;
    }
    return requestConfig;
  },
  (error) => {
    if (error.response?.status === HttpStatusCode.Unauthorized) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === HttpStatusCode.Unauthorized) {
      handleUnauthorized();
    } else if (isAccountBlockedError(error)) {
      handleBlocked();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
